import { defineNuxtPlugin } from 'nuxt/app'
import { ObserveVisibility } from 'vue-observe-visibility'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('observe-visibility', {
    beforeMount: (el, binding, vnode) => {
      vnode.context = binding.instance
      ObserveVisibility.bind(el, binding, vnode)
    },
    update: ObserveVisibility.update,
    unmounted: (el, binding, vnode) => {
      if (el && ObserveVisibility && ObserveVisibility.unbind) {
        ObserveVisibility.unbind(el, binding, vnode)
      }
    },
  })
})
